import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Viewing Student Progress",
    intro: "See how each student is doing on the chapters you assigned.",
    steps: [
      "In your teacher dashboard, open Student Progress.",
      "Choose a class, or All Classes. You can also search for a student.",
      "Performance shows each student's average score. Status shows a label from that average: Active (above 50%), Below Average (21% to 50%), Needs Attention (20% or lower) or No assignments. The table also shows the last assignment submitted and the last login.",
      "Open Gradebook to see each assignment: Complete (70% or higher), In Progress, Needs Review (below 70%) or Not Started.",
    ],
    tip: "Answers that can be checked automatically are scored for you.",
  },
  es: {
    title: "Cómo ver el progreso de los estudiantes",
    intro: "Mira cómo va cada estudiante en los capítulos que asignaste.",
    steps: [
      "En tu panel de maestro, abre Progreso de los estudiantes.",
      "Elige una clase o todas las clases. También puedes buscar a un estudiante.",
      "Rendimiento muestra el puntaje promedio de cada estudiante. Estado muestra una etiqueta según ese promedio: activo (más de 50 %), bajo el promedio (de 21 % a 50 %), necesita atención (20 % o menos) o sin tareas. La tabla también muestra la última tarea entregada y el último inicio de sesión.",
      "Abre Calificaciones para ver cada tarea: completo (70 % o más), en curso, por revisar (menos de 70 %) o sin empezar.",
    ],
    tip: "Las respuestas que se pueden revisar de forma automática se califican solas.",
  },
};

export default function ViewingStudentProgress() {
  return <HelpArticle text={TEXT} />;
}
